import { compact, times } from 'lodash';

export function getPlanningWeekDataNoMilestones(numWeeks: number) {
  const values = times(numWeeks, (index) => {
    return {
      id: `week${index + 1}`,
      weekNumber: index + 1,
      year: 2020,
      startDate: '09 Feb 2020',
      endDate: '15 Feb 2020',
      milestones: [],
      commodityMilestoneIds: [],
    };
  });
  const compactValues = compact(values);
  return compactValues;
}
